export default __webpack_public_path__ + "static/media/512.c19f4aad.png";